// extracted by mini-css-extract-plugin
export var standaloneTable = "_ef-0";
export var standaloneTableWithBodyFill = "_ef-1";
export var withExtraHeader = "_ef-2";